import '../../components/dashboardWidgets/widgets.style.scss';

import React, { useContext, useState } from 'react';
import TopBarComponent from '../../components/topBar/TopBar.component';
import StaticIndicator from '../../components/staticIndicators/StaticIndicator';
import MyTasks from '../../components/dashboardWidgets/myTasks';
import TeamTasks from '../../components/dashboardWidgets/teamTasks';
import SingleVarChart from '../AnalyticsScreen.tsx/charts/SingleVarChart';
import { buildAndDownloadCaseCSV } from '../../utils/export-csv';
import { getEnrichedCaseRows } from '../../utils/caseTableService';
import { UserContext, UserContextProps } from '../../App';

const Dashboard: React.FC = () => {
  const { currentUser } = useContext(UserContext) as Partial<UserContextProps>;
  const [exporting, setExporting] = useState(false);
  const [caseData, setCaseData] = useState<any[] | null>(null);

  const handleExport = async () => {
    if (!currentUser?.organisationId) return;
    setExporting(true);
    try {
      const rows = await getEnrichedCaseRows(currentUser.organisationId);
      console.log(rows);
      setCaseData(rows);
      await buildAndDownloadCaseCSV(rows);
    } catch (e) {
      console.error('Export failed:', e);
    } finally {
      setExporting(false);
    }
  };

  return (
    <>
      <TopBarComponent title="Dashboard" hideSearch color="white" style={{ height: '60px' }}>
        <button onClick={handleExport} className="btn btn-primary" disabled={!caseData || exporting || !currentUser?.organisationId}>
          {exporting ? (
            <span style={{ fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '4px' }}>
              Exporting…
              <span className="spinner-border spinner-border-sm text-light" role="status" />
            </span>
          ) : (
            'Export to CSV'
          )}
        </button>
      </TopBarComponent>
      <br />

      <div className="content" style={{ background: '#F5F5F5' }}>
        <StaticIndicator setCaseData={setCaseData} showMain />
        <div className="widgets">
          <div className="row">
            <div className="col-4">
              <MyTasks />
            </div>
            <div className="col-8">
              <TeamTasks />
            </div>
          </div>
        </div>

        <SingleVarChart />
        {/*<div style={{ display: 'flex', flexDirection: 'row' }}>*/}
        {/*  <LineGraphThin />*/}
        {/*  /!*<BarGraph data={quarterData} heading={`Quarterly Cases (${year})`} dataHeading="Active Cases" />*!/*/}
        {/*</div>*/}
        {/*<div style={{ display: 'flex', flexDirection: 'row' }}>*/}
        {/*  <PieChart />*/}
        {/*  /!*<BarGraph data={quarterData} heading={`Quarterly Cases (${year})`} dataHeading="Active Cases" />*!/*/}
        {/*</div>*/}
      </div>
    </>
  );
};

export default Dashboard;
